import {Injectable} from "@angular/core";
import {DesktopModalType, MobileModalType, ModalService} from "@app/presentation/services/modal/modal.service";
import {Observable} from "rxjs";
import {
    ConfirmationModalComponent,
    ConfirmationModalData
} from "@app/presentation/services/confirmation-modal/confirmation-modal.component";


@Injectable()
export class ConfirmationModalService {

    constructor(
       private readonly modalService: ModalService,
    ) {}

    open(params: ConfirmationModalData): Observable<boolean> {
        return this.modalService.open<boolean,ConfirmationModalData>(ConfirmationModalComponent, {
            desktopModalType: DesktopModalType.SIDE_SHEET,
            mobileModalType: MobileModalType.BOTTOM_SHEET,
            data: {
                title: params.title,
                message: params.message,
                acceptButtonText: params.acceptButtonText,
                cancelButtonText: params.cancelButtonText,
            }
        });
    }

}